import React, {useContext} from 'react'
import {useSelector} from 'react-redux'
import {SwipeImageGallery} from 'components/SwipeImageGallery'

import {SkeletonLoader} from '@vio/atlas/src/components/designSystem/SkeletonLoader'

import {getHotel} from '../../../../modules/sapiSearch/selectors'
import {imageProvider} from '../../../../utils/imageProvider'
import {HotelCardContext} from '../../../HotelCardContext'

export const BOVIO_FIRST_CARD_IMAGE_HEIGHT = 185

interface Props {
  isPriorityCard: boolean
  onClick: () => void
}

export const BoVioFirstCardGallery: React.FC<Props> = ({
  isPriorityCard,
  onClick
}) => {
  const {hotelId} = useContext(HotelCardContext)
  const hotel = useSelector(state => getHotel(state, hotelId))
  if (!hotel) return <SkeletonLoader height="100%" />

  return (
    <SwipeImageGallery
      hotelId={hotelId}
      isPriority={isPriorityCard}
      images={hotel.imageURIs ?? []}
      imageHeight={BOVIO_FIRST_CARD_IMAGE_HEIGHT}
      imageProvider={imageProvider}
      onClick={onClick}
    />
  )
}
